import { matchPath } from 'react-router-dom';

export const isMatchingPath = (pathname: string, path: string) => {
    return matchPath(pathname, {
        path,
        exact: true,
        strict: false,
    });
};
